export default __webpack_public_path__ + "static/media/DSC_0510.b13c86e9.jpg";